/* Sharrow header (V3) behaviour, rebuilt for Shopify.
   - mobile menu toggle that scrolls inside itself and freezes the page behind it
   - cart button opens Shopify's cart drawer when the theme uses one
   - cart count updates live when products are added or removed */
(function () {
  'use strict';

  function init() {
    var nav = document.getElementById('sharrowHeaderV3');
    if (!nav || nav.dataset.ready === '1') return;
    nav.dataset.ready = '1';

    var toggle = nav.querySelector('.shv3-toggle');
    var mobileMenu = nav.querySelector('.shv3-mobile');
    var savedScrollY = 0;

    function updateHeaderHeight() {
      window.requestAnimationFrame(function () {
        var topRow = nav.querySelector('.shv3-toprow');
        var mobileTop = topRow ? Math.ceil(topRow.getBoundingClientRect().height) : 70;
        if (mobileTop > 0) document.documentElement.style.setProperty('--shv3MobileTop', mobileTop + 'px');
        var h = Math.ceil(nav.getBoundingClientRect().height);
        if (h > 0) document.documentElement.style.setProperty('--sharrowHeaderV3Height', (h + 12) + 'px');
      });
    }

    function lockPageScroll() {
      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('shv3-menu-open');
      document.body.classList.add('shv3-menu-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('shv3-menu-open');
      document.body.classList.remove('shv3-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function setMobileMenuOpen(isOpen) {
      if (isOpen === nav.classList.contains('is-open')) { updateHeaderHeight(); return; }
      nav.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close navigation' : 'Open navigation');
      if (isOpen) { lockPageScroll(); if (mobileMenu) mobileMenu.scrollTop = 0; }
      else unlockPageScroll();
      updateHeaderHeight();
    }

    toggle.addEventListener('click', function () { setMobileMenuOpen(!nav.classList.contains('is-open')); });
    nav.querySelectorAll('.shv3-mobile a').forEach(function (link) {
      link.addEventListener('click', function () { setMobileMenuOpen(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMobileMenuOpen(false); });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 860) setMobileMenuOpen(false);
      updateHeaderHeight();
    });

    /* Cart: open the theme's cart drawer if there is one, otherwise follow the link to /cart. */
    nav.querySelectorAll('[data-shv3-cart]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        e.preventDefault();
        setMobileMenuOpen(false);
        drawer.open();
      });
    });

    function setCount(n) {
      nav.querySelectorAll('[data-shv3-cart-count]').forEach(function (el) { el.textContent = n; });
    }
    function refreshCount() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); })
        .catch(function () {});
    }
    document.addEventListener('shopify:cart:lines-update', function (e) {
      var p = e && e.promise;
      if (p && typeof p.then === 'function') p.then(refreshCount, refreshCount);
      else window.setTimeout(refreshCount, 600);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

    updateHeaderHeight();
    window.addEventListener('load', updateHeaderHeight);
    if ('ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(nav);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
